module.exports = __webpack_public_path__ + "static/img/expert-list-placeholder.aadbf5af.svg";